//@flow

import ConfirmationModal from "./ConfirmationModal"

export default ConfirmationModal



// WEBPACK FOOTER //
// ./src/Kiosk/ConfirmationModal/index.js